var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C5 1.44772 5.44772 1 6 1H18C18.5523 1 19 1.44772 19 2V8.82355C19 12.7595 15.8931 16 12 16C8.10689 16 5 12.7595 5 8.82355V2ZM7 3V8.82355C7 11.7099 9.26571 14 12 14C14.7343 14 17 11.7099 17 8.82355V3H7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.5C1 4.94772 1.44772 4.5 2 4.5H6C6.55228 4.5 7 4.94772 7 5.5V10.5C7 11.0523 6.55228 11.5 6 11.5C3.35122 11.5 1 9.28393 1 5.5ZM3.07356 6.5C3.31583 8.05489 4.12356 8.93203 5 9.2969V6.5H3.07356Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.5C17 4.94772 17.4477 4.5 18 4.5H22C22.5523 4.5 23 4.94772 23 5.5C23 9.28393 20.6488 11.5 18 11.5C17.4477 11.5 17 11.0523 17 10.5V5.5ZM19 6.5V9.2969C19.8764 8.93203 20.6842 8.05489 20.9264 6.5H19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C12.5523 15 13 15.4477 13 16V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16C11 15.4477 11.4477 15 12 15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4932 17.4761C8.67516 17.1803 8.99764 17 9.345 17H14.5212C14.8573 17 15.171 17.1688 15.356 17.4494L17.3348 20.4494C17.5373 20.7565 17.5549 21.1501 17.3805 21.474C17.2061 21.798 16.8679 22 16.5 22H7.5C7.13777 22 6.80386 21.8041 6.62711 21.4879C6.45037 21.1717 6.45844 20.7847 6.6482 20.4761L8.4932 17.4761ZM9.90398 19L9.28898 20H14.6425L13.9829 19H9.90398Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.d5758584493acdff8eb491fbc7950e97.svg";
export { ForwardRef as ReactComponent };